import { Category } from '@modules/husleie-framework/src/enums/Category.enum';
import type RentalObjectState from '@modules/store/rentalObject/types/RentalObjectState.entity';

export const state: RentalObjectState = {
  loading: null,
  loaded: false,
  rentalObject: {
    category: Category.APARTMENT,
    address: {
      street: '',
      postalCode: '',
      postalArea: '',
      additionalAddress: '',
      apartmentLocation: '',
      country: {
        code: '',
      },
    },
    dateOfConstruction: '',
    squareMeters: null,
  },
};
